<template>
  <div>
    <div class="h-100 w-100 modal-backdrop"></div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div v-if="!submitted && !submitting" class="modal-content">
          <div class="modal-header align-middle">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Request your invite</h5>
            <button type="button" class="close" v-on:click="onCloseClicked">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body request-invite">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="forename" placeholder="First Name"/>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="surname" placeholder="Last Name"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <input type="email" class="form-control" v-bind:value="email" v-on:change="onEmailUpdatedEvent" placeholder="Email"/>
                </div>
              </div>
            </div>
            <p class="text-success"><input type="checkbox" class="form-check-inline" v-model="consentGiven"/> I'm excited to try Itchyfeet, I would like to receive regular updates!</p>
            <button type="button" v-bind:disabled="!canRequestInvite" class="btn btn-lg" v-on:click="requestInvite">Request Invite</button>
          </div>
        </div>
        <div v-if="!submitted && submitting" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Request your invite</h5>
          </div>
          <div class="modal-body">
            <p>Processing . . .</p>
            <font-awesome-icon icon="sync-alt"></font-awesome-icon>
          </div>
        </div>

        <div v-if="submitted && !submitting && submissionError" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Error Occurred</h5>
            <button type="button" class="close" v-on:click="onCloseClicked">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div v-if="submissionError" class="modal-body">
            <p>Unknown error. Please try again later.</p>
          </div>
        </div>

        <div v-if="submitted && !submitting && !submissionError" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Thank You!</h5>
            <button type="button" class="close" v-on:click="onCloseClicked">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <h5 class="">We have added your email to the waiting list!</h5>

            <hr />

            <p>Interest in <strong class="text-success">priority access</strong>? Get earlier access by referring your friends. The more friends that join, the sooner you will get access.</p>

            <p>Share this unique link to invite your real friends to the platform as well. Additionally, if you reach <span class="referral-count">10 referrals</span>, you will have access to a premium account.</p>

            <div class="input-group">
              <input class="form-control" v-bind:value="submissionResponse.shareLink" readonly />
              <div class="input-group-append">
                <button class="btn" v-on:click="doCopy">Copy</button>
              </div>
            </div>

            <p class="text-center mt-3">Or</p>

            <a class="btn btn-success text-white" target="_blank" v-bind:href="submissionResponse.twitterLink">Twitter</a>
            <a class="btn btn-primary text-white" target="_blank" v-bind:href="submissionResponse.facebookLink">Facebook</a>
            <a class="btn btn-secondary text-dark" target="_blank" v-bind:href="submissionResponse.mailtoLink">Email</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {postToWaitingList} from '../../api'

export default {
  name: 'RequestInviteModal',
  props: ['email', 'onCloseClicked', 'originalCount', 'onEmailUpdated'],
  data: function () {
    return {
      submitting: false,
      submitted: false,
      submissionResponse: false,
      submissionError: false,
      forename: '',
      surname: '',
      consentGiven: false
    }
  },
  computed: {
    canRequestInvite: function () {
      if (this.submitting || this.submitted || !this.consentGiven) {
        return false
      }

      if (!this.forename || this.forename.length === 0 || !this.surname || this.surname.length === 0) {
        return false
      }

      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.email).toLowerCase())
    }
  },
  methods: {
    requestInvite: function () {
      this.submissionError = false

      let referrerCode = window.localStorage.getItem('referrer')
      let myUniqueCode = window.localStorage.getItem('myUniqueCode')

      if (!(referrerCode || myUniqueCode || (referrerCode && referrerCode.length !== 8) || referrerCode === myUniqueCode)) {
        referrerCode = false
      }

      postToWaitingList(this.email, this.forename, this.surname, referrerCode).then((response) => {
        this.submissionResponse = response
        this.submitted = true
        this.submitting = false
        this.onEmailUpdated('')

        window.localStorage.setItem('myUniqueCode', response.uniqueCode)
      }).catch(() => {
        this.submissionResponse = false
        this.submissionError = true
        this.submitted = false
        this.submitting = false
      })

      this.$ua.trackEvent({
        eventCategory: 'Waiting List', eventAction: 'Click', eventLabel: 'Request Invite Submitted', eventValue: 'Request Invite Submitted'
      })
    },
    doCopy: function () {
      this.$copyText(this.submissionResponse.shareLink).then(function (e) {}, function (e) {})
    },
    onEmailUpdatedEvent: function (e) {
      this.email = e.target.value
      this.onEmailUpdated(e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .request-invite .btn.btn-success {
    border: 2px solid #6752DD;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/RequestInviteModal.vue